"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _internal = require("../../theme/internal");
var _token = require("./token");
// =============================== OTP ================================
var genOTPStyle = function genOTPStyle(token) {
  var componentCls = token.componentCls,
    paddingXS = token.paddingXS;
  return _defineProperty({}, componentCls, _defineProperty(_defineProperty(_defineProperty({
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    columnGap: paddingXS,
    '&-rtl': {
      direction: 'rtl'
    }
  }, "".concat(componentCls, "-input"), {
    textAlign: 'center',
    paddingInline: token.paddingXXS
  }), "&".concat(componentCls, "-sm ").concat(componentCls, "-input"), {
    paddingInline: token.calc(token.paddingXXS).div(2).equal()
  }), "&".concat(componentCls, "-lg ").concat(componentCls, "-input"), {
    paddingInline: token.paddingXS
  }));
};
// ============================== Export ==============================
var _default = exports["default"] = (0, _internal.genStyleHooks)(['Input', 'OTP'], function (token) {
  var inputToken = (0, _internal.mergeToken)(token, (0, _token.initInputToken)(token));
  return [genOTPStyle(inputToken)];
}, _token.initComponentToken);